import React from "react";
import { useTranslation } from "react-i18next";
import { ContractualAccountStatus } from "features/contractualAccounts/enums/contractualAccountStatus";

interface Props {
  status: ContractualAccountStatus;
}

const ContractualAccountStatusLabel = ({ status }: Props) => {
  const { t } = useTranslation(["contractualAccounts\\enums\\contractualAccountStatus"]);

  switch (status) {
    case ContractualAccountStatus.Effective:
      return (
        <span className="badge badge-pill badge-success small font-weight-normal">
          {t(status)}
        </span>
      );
    case ContractualAccountStatus.Terminated:
      return (
        <span className="badge badge-pill badge-danger small font-weight-normal">
          {t(status)}
        </span>
      );
    default:
      return null;
  }
};

export default ContractualAccountStatusLabel;
